import { registerBlockType } from '@wordpress/blocks';
import './style.scss';
import './editor.scss';
import Edit from './edit';
import save from './save';
import metadata from './block.json';
import indexJson from './edit.json';
import advancejson from '@vayu-blocks/advance-panel/advance.json';
import { IoGridOutline } from "react-icons/io5";


registerBlockType( metadata.name, {
	...metadata,
	attributes: { ...indexJson, ...advancejson },
	edit: Edit,
	icon: <IoGridOutline style={{color:'#6c1bc3'}} />,
	save,
} );
